const baseURL = "";

/**
 *
 * @param {string} url - API， 开头需要加 /
 * @returns {string}
 */
const makeURL = (url) => `${baseURL}${url}`;

const api = {

};

export default {
  api,
};
